enum Gender {
    FEMALE = 'FEMALE',
    MALE = 'MALE',
    BOTH = 'BOTH'
}

export default Gender;
